<!-- 产品详情 -->
<template>
  <div>
    <el-form ref="form"
             :model="xqlist"
             label-width="100px">
      <el-form-item label="产品名"
                    prop="name">
        <el-col :span="8">
          <el-input v-model="xqlist.name"
                    :disabled="true" />
        </el-col>
      </el-form-item>
      <el-form-item label="产品名缩写"
                    prop="shortName">
        <el-col :span="8">
          <el-input v-model="xqlist.shortName"
                    :disabled="true"
                    placeholder="产品名缩写" />
        </el-col>
      </el-form-item>
      <el-form-item label="产品简介"
                    prop="shortIntroduce">
        <el-input v-model="xqlist.shortIntroduce"
                  :disabled="true" />
      </el-form-item>
      <el-form-item label="产品详情"
                    prop="introduce">
        <div v-html="xqlist.introduce"></div>
      </el-form-item>

      <el-form-item label="所属产品"
                    prop="productName">
        <el-col :span="8">
          <el-input v-model="xqlist.productName"
                    :disabled="true"
                   />
        </el-col>
      </el-form-item>
      <el-form-item label="品牌标签"
                    prop="label">
        <el-col :span="8">
          <el-input :value="Array.isArray(xqlist.label) ? xqlist.label.join('、') : xqlist.label"
                    :disabled="true"
                   />
        </el-col>
      </el-form-item>
      <el-form-item label="产品保障服务"
                    prop="guarantee">
        <el-col :span="8">
          <el-input :value="Array.isArray(xqlist.guarantees) ? xqlist.guarantees.join('、') : xqlist.guarantees"
                    :disabled="true"
                   />
        </el-col>
      </el-form-item>

      <el-form-item label="产品封面"
                    prop="cover">
        <el-image style="width: 100px; height: 100px"
                  :preview-src-list="carouselList"
                  :src="carouselList[0]">
          <div slot="error"
               class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </el-form-item>
      <el-form-item label="主产品封面"
                    prop="keyCover">
        <el-image style="width: 100px; height: 100px"
                  :preview-src-list="xqlist.keyCover ? [$url + xqlist.keyCover] : []"
                  :src="xqlist.keyCover ? $url + xqlist.keyCover : ''">
          <div slot="error"
               class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </el-form-item>
      <el-form-item v-if="xqlist.scope==2"
                    label="私有二维码"
                    prop="cover">
        <el-image style="width: 100px; height: 100px"
                  :preview-src-list="privateQrCodeList"
                  fit="contain"
                  :src="privateQrCodeList[0]">
          <div slot="error"
               class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </el-form-item>

      <el-form-item label="主产品轮播图"
                    prop="image">
        <el-image style="width: 100px; height: 100px"
                  :preview-src-list=" xqlist.keyImages"
                  :src="xqlist.keyImages[index]"
                  v-for="(item,index) in xqlist.keyImages"
                  :key="index">
          <div slot="error"
               class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </el-form-item>
      <el-form-item label="主产品介绍图"
                    prop="infoImageList">
        <el-image style="width: 100px; height: 100px"
                  :preview-src-list=" xqlist.keyInfoImageList"
                  :src="xqlist.keyInfoImageList[index]"
                  v-for="(item,index) in xqlist.keyInfoImageList"
                  :key="index">
          <div slot="error"
               class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </el-form-item>
      <el-form-item label="价格"
                    prop="price">
        <el-col :span="8">
          <el-input v-model="xqlist.price"
                    :disabled="true" />
        </el-col>
      </el-form-item>

      <el-form-item label="销售量"
                    prop="salesVolume">
        <el-col :span="8">
          <el-input v-model="xqlist.salesVolume"
                    :disabled="true" />
        </el-col>
      </el-form-item>
      <el-form-item label="开放范围"
                    prop="
                    price">
        <el-col :span="10">
          <el-radio v-model="xqlist.scope"
                    :disabled="true"
                    :label=0>对所有人开放</el-radio>
          <el-radio v-model="xqlist.scope"
                    :disabled="true"
                    :label=1>对旧代理开放</el-radio>
          <el-radio v-model="xqlist.scope"
                    :disabled="true"
                    :label=2>对所有人不开放</el-radio>
        </el-col>
      </el-form-item>
      <el-form-item label="是否预约"
                    prop="
                    price">
        <el-col :span="8">
          <el-radio v-model="xqlist.isCanAppointment"
                    :disabled="true"
                    :label=0>是</el-radio>
          <el-radio v-model="xqlist.isCanAppointment"
                    :disabled="true"
                    :label=1>否</el-radio>
        </el-col>
      </el-form-item>
      <el-form-item label="品类类型"
                    prop="category">
        <el-col :span="8">
          <el-radio v-model="xqlist.category"
                    :disabled="true"
                    :label=0>筛查</el-radio>
          <el-radio v-model="xqlist.category"
                    :disabled="true"
                    :label=1>保健</el-radio>
          <el-radio v-model="xqlist.category"
                    :disabled="true"
                    :label=2>公益</el-radio>
        </el-col>
      </el-form-item>
      <el-form-item label="增值">
        <el-col :span="8">
          <el-radio v-model="xqlist.isValueAdd"
                    :disabled="true"
                    :label=0>否</el-radio>
          <el-radio v-model="xqlist.isValueAdd"
                    :disabled="true"
                    :label=1>是</el-radio>
        </el-col>
      </el-form-item>
      <el-form-item label="分类"
                    prop="type">
        <el-col :span="8">
          <el-input v-model="xqlist.type"
                    :disabled="true" />
        </el-col>

      </el-form-item>

      <el-form-item label="创建时间"
                    prop="createTime">
        <el-col :span="8">
          <el-input v-model="xqlist.createTime"
                    :disabled="true"
                    placeholder="创建时间" />
        </el-col>

      </el-form-item>
      <el-form-item label="修改时间"
                    prop="updateTime">
        <el-col :span="8">
          <el-input v-model="xqlist.updateTime"
                    :disabled="true"
                    placeholder="修改时间" />
        </el-col>
      </el-form-item>
      <el-button @click="back"
                 type="success">返回产品列表</el-button>
      <el-button v-if="authAttr>1"
                 type="primary"
                 icon="el-icon-edit"
                 @click="updateContent()">修改内容</el-button>
      <el-button v-if="authAttr>1"
                 type="primary"
                 icon="el-icon-edit"
                 @click="updateImages()">修改产品封面</el-button>
      <el-button v-if="authAttr>1"
                  type="primary"
                  icon="el-icon-edit"
                  @click="updateMainContent()">修改主产品内容</el-button>
      <el-button v-if="authAttr>1"
                 type="primary"
                 icon="el-icon-edit"
                 @click="updateMainImages()">修改主产品封面和轮播图</el-button>
      
      <el-button v-if="authAttr>1"
                 type="primary"
                 icon="el-icon-edit"
                 @click="OpenProductInfoImageFrame()">修改主产品介绍图片</el-button>
      <el-button v-if="authAttr>1"
                 type="primary"
                 icon="el-icon-edit"
                 @click="OpenProductRebate()">修改产品返利列表</el-button>
      <el-button v-if="authAttr>2"
                 type="danger"
                 icon="el-icon-delete"
                 @click="delHandler()">失效</el-button>
    </el-form>
    <!-- 修改封面图对话框 -->
    <template>
      <el-dialog title="修改产品封面"
                 :visible.sync="alterProductImages"
                 width="50%">
        <p>修改图片为重新上传（封面和图片至少选择一个）</p><br>
        <div class="demo-input-suffix">
          <el-form ref="form"
                   label-width="80px">
            <el-form-item label="封面(单选)">
              <el-upload action="#"
                         ref="upload4"
                         :headers="headers"
                         :limit="1"
                         :data='recompose'
                         :auto-upload="false"
                         list-type="picture-card"
                         :on-remove="productCoverRemove"
                         :on-change="productCoverChange">
                <i class="el-icon-plus"></i>
              </el-upload>
              <span style="color:coral">请上传图片类型为jpg或png格式且大小不高于2M的图片</span>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="alterProductImages = false">取 消</el-button>
          <el-button type="success"
                     @click="updateArticleImages">提交</el-button>
        </span>
      </el-dialog>
    </template>
    <!-- 修改主产品封面和轮播图对话框 -->
    <template>
      <el-dialog title="修改主产品封面和轮播图"
                 :visible.sync="mainAlterProductImages"
                 width="50%">
        <p>修改图片为重新上传（封面和图片至少选择一个）</p><br>
        <div class="demo-input-suffix">
          <el-form ref="form"
                   label-width="80px">
            <el-form-item label="图片(多选)">
              <el-upload action="#"
                         ref="upload3"
                         :headers="headers"
                         multiple
                         :data='recompose'
                         :auto-upload="false"
                         :file-list="fileList"
                         list-type="picture-card"
                         :on-remove="mainImagesRemove"
                         :on-change="mainImagesChange">
                <i class="el-icon-plus"></i>
              </el-upload>
              <span style="color:coral">请上传图片类型为jpg或png格式且大小不高于2M的图片</span>
            </el-form-item>
            <el-form-item label="封面(单选)">
              <el-upload action="#"
                         ref="upload4"
                         :headers="headers"
                         :limit="1"
                         :data='recompose'
                         :auto-upload="false"
                         list-type="picture-card"
                         :on-remove="mainImagesRemove"
                         :on-change="mainCoverChange">
                <i class="el-icon-plus"></i>
              </el-upload>
              <span style="color:coral">请上传图片类型为jpg或png格式且大小不高于2M的图片</span>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="mainAlterProductImages = false">取 消</el-button>
          <el-button type="success"
                     @click="updateMainArticleImages">提交</el-button>
        </span>
      </el-dialog>
    </template>

    <!-- 修改主产品介绍图片 -->
    <template>
      <el-dialog title="修改主产品介绍图片"
                 :visible.sync="ProductInfoImage"
                 width="50%">
        <p>修改图片为重新上传</p><br>
        <div class="demo-input-suffix">
          <el-form ref="form"
                   label-width="80px">
            <el-form-item label="图片(多选)">
              <el-upload action="#"
                         ref="productImg"
                         :headers="headers"
                         multiple
                         :auto-upload="false"
                         :file-list="fileList"
                         list-type="picture-card"
                         :on-remove="mainImagesRemove"
                         :on-change="mainImagesChange">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>

          </el-form>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="ProductInfoImage = false">取 消</el-button>
          <el-button type="success"
                     @click="uploadProductInfoImage">提交</el-button>
        </span>
      </el-dialog>
    </template>

    <template>
      <el-dialog title="修改信息"
                 :visible.sync="alterProduct"
                 width="50%">
        <el-form ref="form"
                 :model="xqlist"
                 label-width="100px">
          <el-form-item label="产品名"
                        prop="name">
            <el-input v-model="xqlist.name"
                      placeholder="请输入产品名" />
          </el-form-item>
          <el-form-item label="产品名缩写"
                        prop="shortName">
            <el-input v-model="xqlist.shortName"
                      placeholder="产品名缩写" />
          </el-form-item>
          <el-form-item label="产品简介"
                        prop="shortIntroduce">
            <el-input v-model="xqlist.shortIntroduce"
                      placeholder="请输入产品简介" />
          </el-form-item>
          <el-form-item label="产品详情"
                        prop="introduce">
            <el-input type="textarea"
                      v-model="xqlist.introduce"></el-input>
          </el-form-item>
          <el-form-item label="价格"
                        prop="price">
            <el-input v-model="xqlist.price"
                      placeholder="请输入价格" />
          </el-form-item>
          <el-form-item label="销量"
                        prop="salesVolume">
            <el-input v-model="xqlist.salesVolume"
                      placeholder="请输入销量" />
          </el-form-item>
           <el-form-item label="所属产品"
                          prop="productKeyId">
              <el-select size="medium"
                         v-model="xqlist.productKeyId"
                         placeholder="请选择所属产品类型">
                <el-option :label="productKey.productName" v-for="productKey in productKeyList"
                           :key="productKey.id"
                           :value="productKey.id"></el-option>
              </el-select>
            </el-form-item>
           <!-- <el-form-item label="品牌标签"
                          prop="label">
              <div v-for="(label, index) in labelList"
                   :key="index"
                   class="label-item">
                <el-input v-model="labelList[index]"
                          placeholder="请输入品牌标签" />
                <el-button type="primary"
                           icon="el-icon-plus"
                           circle
                           @click="addLabel"></el-button>
                <el-button type="primary"
                           icon="el-icon-minus"
                           v-if="index > 0"
                           text="删除"
                           @click="removeLabel(index)"></el-button>
              </div>
            </el-form-item>
             <el-form-item label="品牌保障标签"
                          prop="label">
              <div v-for="(label, index) in guaranteeList"
                   :key="index"
                   class="label-item">
                <el-input v-model="guaranteeList[index]"
                          placeholder="请输入品牌保障标签" />
                <el-button type="primary"
                           icon="el-icon-plus"
                           circle
                           @click="addGuarantee"></el-button>
                <el-button type="primary"
                           icon="el-icon-minus"
                           v-if="index > 0"
                           text="删除"
                           @click="removeGuarantee(index)"></el-button>
              </div>
            </el-form-item> -->
          <el-form-item label="开放范围"
                        prop="scope">
            <el-select v-model="xqlist.scope"
                       placeholder="请选择开发范围">
              <el-option label="对所有人开放"
                         :value=0></el-option>
              <el-option label="对旧代理开放"
                         :value=1></el-option>
              <el-option label="对所有人不开放"
                         :value=2></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否预约">
            <el-radio v-model="xqlist.isCanAppointment"
                      :label=0>是</el-radio>
            <el-radio v-model="xqlist.isCanAppointment"
                      :label=1>否</el-radio>
          </el-form-item>
          <el-form-item label="品类">
            <el-select size="medium"
                       v-model="xqlist.category"
                       placeholder="请选择品类类型">
              <el-option label="筛查"
                         :value="0"></el-option>
              <el-option label="保健"
                         :value="1"></el-option>
              <el-option label="公益"
                         :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="增值">
            <el-select size="medium"
                       v-model="xqlist.isValueAdd"
                       placeholder="请选择是否增值">
              <el-option label="否"
                         :value="0"></el-option>
              <el-option label="是"
                         :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分类"
                        prop="type">
            <el-input v-model="xqlist.type"
                      placeholder="请输入分类" />
          </el-form-item>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="alterProduct = false">取 消</el-button>
          <el-button type="primary"
                     @click="changexx">提 交</el-button>
        </span>
      </el-dialog>
    </template>

    <template>
      <el-dialog title="修改主产品信息"
                 :visible.sync="alterMainProduct"
                 width="50%">
        <el-form ref="form"
                 :model="mainlist"
                 label-width="100px">
          <el-form-item label="产品名"
                        prop="productName">
            <el-input v-model="mainlist.productName"
                      placeholder="请输入产品名" />
          </el-form-item>
            <el-form-item label="品牌标签"
                          prop="label">
              <div v-for="(label, index) in labelList"
                   :key="index"
                   class="label-item">
                <el-input v-model="labelList[index]"
                          placeholder="请输入品牌标签" />
                <el-button type="primary"
                           icon="el-icon-plus"
                           circle
                           @click="addLabel"></el-button>
                <el-button type="primary"
                           icon="el-icon-minus"
                           v-if="index > 0"
                           text="删除"
                           @click="removeLabel(index)"></el-button>
              </div>
            </el-form-item>
             <el-form-item label="品牌保障标签"
                          prop="label">
              <div v-for="(label, index) in guaranteeList"
                   :key="index"
                   class="label-item">
                <el-input v-model="guaranteeList[index]"
                          placeholder="请输入品牌保障标签" />
                <el-button type="primary"
                           icon="el-icon-plus"
                           circle
                           @click="addGuarantee"></el-button>
                <el-button type="primary"
                           icon="el-icon-minus"
                           v-if="index > 0"
                           text="删除"
                           @click="removeGuarantee(index)"></el-button>
              </div>
            </el-form-item>
          <el-form-item label="开放范围"
                        prop="scope">
            <el-select v-model="mainlist.scope"
                       placeholder="请选择开发范围">
              <el-option label="对所有人开放"
                         :value=0></el-option>
              <el-option label="对旧代理开放"
                         :value=1></el-option>
              <el-option label="对所有人不开放"
                         :value=2></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品类">
            <el-select size="medium"
                       v-model="mainlist.category"
                       placeholder="请选择品类类型">
              <el-option label="筛查"
                         :value="0"></el-option>
              <el-option label="保健"
                         :value="1"></el-option>
              <el-option label="公益"
                         :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="增值">
            <el-select size="medium"
                       v-model="mainlist.isValueAdd"
                       placeholder="请选择是否增值">
              <el-option label="否"
                         :value="0"></el-option>
              <el-option label="是"
                         :value="1"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="分类"
                        prop="type">
            <el-input v-model="mainlist.type"
                      placeholder="请输入分类" />
          </el-form-item> -->
        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="alterMainProduct = false">取 消</el-button>
          <el-button type="primary"
                     @click="changeMainProduct">提 交</el-button>
        </span>
      </el-dialog>
    </template>

    <template>
      <el-dialog title="修改产品返利列表"
                 :visible.sync="productRebateDialog"
                 width="50%">
        <div class="chain">
          <div class="chain1">链1</div>
          <div class="chainRight">
            <div class="identity">市级:</div>
            <div> <el-input type="number"
                        v-model="productRebateList.line1[0]"
                        size="mini"
                        :min="0"
                        label="描述文字"></el-input></div>

          </div>
          <div class="chainRight">
            <div class="identity">县级:</div>
            <div> <el-input type="number"
                        v-model="productRebateList.line1[1]"
                        size="mini"
                        :min="0"
                        label="描述文字"></el-input></div>

          </div>
          <div class="chainRight">
            <div class="identity">个人:</div>
            <div><el-input type="number"
                        v-model="productRebateList.line1[2]"
                        size="mini"
                        :min="0"
                        label="描述文字"></el-input></div>

          </div>
        </div>
        <div class="chain">
          <div class="chain1">链2</div>
          <div class="chainRight">
            <div class="identity">市级:</div>
            <div> <el-input type="number"
                        v-model="productRebateList.line2[0]"
                        size="mini"
                        :min="0"
                        label="描述文字"></el-input></div>

          </div>
          <div class="chainRight">
            <div class="identity">县级:</div>
            <div> <el-input type="number"
                        v-model="productRebateList.line2[1]"
                        size="mini"
                        :min="0"
                        label="描述文字"></el-input></div>

          </div>
        </div>
        <div class="chain">
          <div class="chain1">链3</div>
          <div class="chainRight">
            <div class="identity">市级:</div>
            <div> <el-input type="number"
                        v-model="productRebateList.line3[0]"
                        size="mini"
                        :min="0"
                        label="描述文字"></el-input></div>

          </div>
          <div class="chainRight">
            <div class="identity">个人:</div>
            <div> <el-input type="number"
                        v-model="productRebateList.line3[1]"
                        size="mini"
                        :min="0"
                        label="描述文字"></el-input></div>

          </div>
        </div>

        <div class="chain">
          <div class="chain1">链4</div>
          <div class="chainRight">
            <div class="identity">市级:</div>
            <div> <el-input type="number"
                        v-model="productRebateList.line4[0]"
                        size="mini"
                        :min="0"
                        label="描述文字"></el-input></div>

          </div>
        </div>
        <div class="rebate">
          <div class="identity">市级返居间:</div>
          <div> <el-input type="number"
                      v-model="productRebateList.intermediaryFeeList[0]"
                      size="mini"
                      :min="0"
                      label="描述文字"></el-input></div>
        </div>
        <div class="rebate">
          <span class="identity">县级返居间:</span>
          <span> <el-input type="number"
                      v-model="productRebateList.intermediaryFeeList[1]"
                      size="mini"
                      :min="0"
                      label="描述文字"></el-input></span>
        </div>
        <div class="rebate">
          <span class="identity">个人返居间:</span>
          <span> <el-input type="number"
                      v-model="productRebateList.intermediaryFeeList[2]"
                      size="mini"
                      :min="0"
                      label="描述文字"></el-input></span>
        </div>

        <div class="rebate">
          <span class="identity">特级返居间市级:</span>
          <span> <el-input type="number"
                      v-model="productRebateList.superIntermediaryFeeList[0]"
                      size="mini"
                      :min="0"
                      label="描述文字"></el-input></span>
        </div>
        <div class="rebate">
          <span class="identity">特级返居间县级:</span>
          <span> <el-input type="number"
                      v-model="productRebateList.superIntermediaryFeeList[1]"
                      size="mini"
                      :min="0"
                      label="描述文字"></el-input></span>
        </div>
        <div class="rebate">
          <span class="identity">特级返居间个人:</span>
          <span> <el-input type="number"
                      v-model="productRebateList.superIntermediaryFeeList[2]"
                      size="mini"
                      :min="0"
                      label="描述文字"></el-input></span>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="productRebateDialog = false">取 消</el-button>
          <el-button type="primary"
                     @click="modifyProductRebateInfo()">提 交</el-button>
        </span>
      </el-dialog>
    </template>

  </div>
</template>

<script>
import CKEditor from 'ckeditor4-vue'
export default {
  components: {
    ckeditor: CKEditor.component
  },
  data() {
    return {
      // 富文本编辑器的配置
      editorConfig: {},
      headers: {
        token: sessionStorage.getItem('token')
      },
      fileList: [],
      headFile: '',
      headFileList: '',
      codeFile: '',
      codeFileList: '',
      alterProductImages: false,
      mainAlterProductImages: false,
      ProductInfoImage: false,
      alterProduct: false,
      alterMainProduct:false,
      productRebateDialog: false,
      authAttr: '',
      productid: '',
      productId: '',
      pageNum: '',
      xqlist: {
        id: '',
        number: '',
        name: '',
        shortName: '',
        shortIntroduce: '',
        introduce: '',
        cover: '',
        List: '',
        images: '',
        price: '',
        type: '',
        createTime: '',
        updateTime: '',
        salesVolume: '',
        scope: '',
        isCanAppointment: '',
        category: '',
        productKeyId :'',
        label: '',
        guarantees: '',
        keyCover: ''
      },
      mainlist:{
         id: '',
        productName: '',
        status: '',
        cover: '',
        images: '',
        salesVolume: '',
        scope: '',
        isCanAppointment: '',
        category: '',
        productKeyId :'',
        label: '',
        guarantees: ''

      },
      //添加产品信息
      recompose: {
        shortName: '',
        name: '',
        shortIntroduce: '',
        status: '0',
        introduce: '',
        price: '',
        type: '',
        cover: null,
        images: null
      },
      productRebateList: {
        line1: [],
        line2: [],
        line3: [],
        line4: [],
        intermediaryFeeList: [],
        superIntermediaryFeeList: []
      },
      carouselList: [],
      privateQrCodeList: [],
      productKeyList: [],
      labelList: [],
      guaranteeList: [],
      productKeyId: '',
    }
  },
  mounted() {
    this.getAuthAttr()
    this.pageNum = this.$route.query.pageNum
    if (this.$route.query.id != undefined) {
      window.sessionStorage.setItem('productid', this.$route.query.id)
      var id = window.sessionStorage.getItem('productid')
      this.productid = id
      this.updateHandler()
    } else {
      var id = window.sessionStorage.getItem('productid')
      this.productid = id
      this.updateHandler()
    }
    this.getProductRebateInfo()
  },

  methods: {
    //失效产品
    async delHandler(index) {
      const msg = await this.$confirm('你确定要失效该产品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      if (msg === 'confirm') {
        //做删除操作
        const { data: res } = await this.$http.post(`/admin/product/invalidProduct?id=${this.xqlist.id}`)
        if (res.code != 200) {
          return this.$message.error(res.msg)
        } else {
          this.back()
          return this.$message.success('失效产品成功')
        }
      }
    },
    // 修改封面和轮播图按钮
    updateImages() {
      this.productId = this.xqlist.id
      this.alterProductImages = true
    },
    updateMainImages() {
      this.productId = this.xqlist.id
      this.mainAlterProductImages = true
    },
    // 打开修改产品介绍图片对话框
    OpenProductInfoImageFrame() {
      this.productId = this.xqlist.id
      this.ProductInfoImage = true
    },
    // 打开修改产品返利列表
    OpenProductRebate() {
      this.productRebateDialog = true
    },
    // 获取产品返利列表
    async getProductRebateInfo() {
      const { data: res } = await this.$http.get(`/admin/product/getProductRebateInfo?id=${this.productid}`)
      this.productRebateList = res.data
    },
    async modifyProductRebateInfo() {
      this.productRebateList.id = this.productid
      const { data: res } = await this.$http.post('/admin/product/modifyProductRebateInfo', this.productRebateList)
      if (res.code == 200) {
        this.productRebateDialog = false
        this.$message.success('修改产品返利成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    getAuthAttr() {
      var authAttr = window.sessionStorage.getItem('auth-4')
      this.authAttr = authAttr
    },
    // 打开主产品弹框
    async updateMainContent() {
      this.alterMainProduct = true
       const { data: res } = await this.$http.get(`/admin/product/getProductKeyInfoById?id=${this.productKeyId}`)
      this.mainlist = res.data
      this.mainlist.productKeyId = this.mainlist.productKeyId
      this.labelList = Array.isArray(this.mainlist.label) && this.mainlist.label.length ? [...this.mainlist.label] : ['']
      this.guaranteeList = Array.isArray(this.mainlist.guarantees) && this.mainlist.guarantees.length ? [...this.mainlist.guarantees] : ['']
      this.mainlist.name=this.mainlist.productName
    },
    //提交主产品
    async changeMainProduct() {
      this.alterMainProduct = false
      var fileFormData = new FormData()
      fileFormData.append('productName', this.mainlist.productName)
      //fileFormData.append('status', this.mainlist.shortIntroduce)
      fileFormData.append('id', this.productKeyId)
      fileFormData.append('scope', this.mainlist.scope)
      fileFormData.append('category', this.mainlist.category)
      fileFormData.append('isValueAdd', this.mainlist.isValueAdd)
      fileFormData.append('label', this.labelList.filter(item => item != null && String(item).trim() !== '').join(';'))
      fileFormData.append('guarantee', this.guaranteeList.filter(item => item != null && String(item).trim() !== '').join(';'))
      console.log(fileFormData)
      const { data: res } = await this.$http.post(`/admin/product/changeMainProductInfo`, fileFormData)
      if (res.code == 200) {
        this.$message.success('修改成功')
      }
      this.alterProduct = false
      this.updateHandler()
    },
    async updateContent() {
      this.alterProduct = true
      const { data: res } = await this.$http.get(`/admin/product/getProductInfoById?id=${this.xqlist.id}`)
      this.xqlist = res.data
      this.xqlist.productKeyId = this.xqlist.productKeyId
      this.labelList = Array.isArray(this.xqlist.label) && this.xqlist.label.length ? [...this.xqlist.label] : ['']
      this.guaranteeList = Array.isArray(this.xqlist.guarantees) && this.xqlist.guarantees.length ? [...this.xqlist.guarantees] : ['']
      this.getAddableProduct()
    },
    async getAddableProduct() {
      const { data: res } = await this.$http.get(`/admin/productKey/getAddableProductList`)
      if(res.code == 200){
        this.productKeyList = res.data
      }
    },
    addLabel() {
      this.labelList.push('')
    },
    removeLabel(index) {
      this.labelList.splice(index, 1)
    },
    addGuarantee() {
      this.guaranteeList.push('')
    },
    removeGuarantee(index) {
      this.guaranteeList.splice(index, 1)
    },
    async updateHandler() {
      const { data: res } = await this.$http.get(`/admin/product/getProductInfoById?id=${this.productid}`)
      //获取数据
      const {
        id,
        number,
        name,
        shortName,
        shortIntroduce,
        introduce,
        cover,
        List,
        images,
        price,
        type,
        createTime,
        updateTime,
        infoImageList,
        salesVolume,
        scope,
        isCanAppointment,
        privateQrCode,
        category,
        isValueAdd,
        productName,
        label,
        guarantees,
        productKeyId,
        keyCover,
        keyImages,
        keyInfoImageList
      } = res.data
      this.carouselList = []
      this.privateQrCodeList = []
      this.carouselList.push(this.$url + res.data.cover)
      this.privateQrCodeList.push('data:image/png;base64,' + res.data.privateQrCode)
      this.xqlist = {
        ...this.xqlist,
        id,
        number,
        name,
        shortName,
        shortIntroduce,
        introduce,
        cover,
        List,
        images,
        price,
        type,
        createTime,
        updateTime,
        infoImageList,
        salesVolume,
        scope,
        isCanAppointment,
        privateQrCode,
        category,
        isValueAdd,
        productName,
        label,
        guarantees,
        keyCover,
        keyImages,
        keyInfoImageList
      }
      this.productKeyId=res.data.productKeyId
      this.xqlist.introduce = this.xqlist.introduce.replace(/\<img /gi, '<img class="rich_pages" ')
      this.xqlist.keyInfoImageList = []
      this.xqlist.keyImages = []
      if (res.data.keyInfoImageList != null && res.data.keyInfoImageList != '') {
        res.data.keyInfoImageList.forEach((e) => {
          this.xqlist.keyInfoImageList.push(this.$url + e)
        })
      }
      if (res.data.keyImages != null && res.data.keyImages != '') {
        res.data.keyImages.forEach((e) => {
          this.xqlist.keyImages.push(this.$url + e)
        })
      }
    },
    // 修改信息提交
    async changexx() {
      var fileFormData = new FormData()
      fileFormData.append('name', this.xqlist.name)
      if (this.xqlist.shortName != null) {
        fileFormData.append('shortName', this.xqlist.shortName)
      }
      fileFormData.append('shortIntroduce', this.xqlist.shortIntroduce)
      fileFormData.append('price', this.xqlist.price)
      fileFormData.append('introduce', this.xqlist.introduce)
      fileFormData.append('type', this.xqlist.type)
      fileFormData.append('id', this.xqlist.id)
      fileFormData.append('salesVolume', this.xqlist.salesVolume)
      fileFormData.append('scope', this.xqlist.scope)
      fileFormData.append('category', this.xqlist.category)
      fileFormData.append('isValueAdd', this.xqlist.isValueAdd)
      fileFormData.append('isCanAppointment', this.xqlist.isCanAppointment)
      fileFormData.append('productKeyId', this.xqlist.productKeyId)
      const { data: res } = await this.$http.post(`/admin/product/changeProductInfo`, fileFormData)
      if (res.code == 200) {
        this.$message.success('修改成功')
      }
      this.alterProduct = false
      this.updateHandler()
    },
    // 修改封面提交
    async updateArticleImages() {
      let fileFormData = new FormData()
      // this.fileList.forEach((f) => {
      //   fileFormData.append('images', f.raw)
      // })
      fileFormData.append('cover', this.cover)
      fileFormData.append('id', this.xqlist.id)
      const { data: res } = await this.$http.post(`/admin/product/uploadProductImage`, fileFormData)
      if (res.code == 200) {
        this.$message.success('修改成功')
        // this.$refs.upload3.clearFiles()
        this.$refs.upload4.clearFiles()
        this.recompose = {}
        this.cover = ''
       // this.fileList = []
        this.updateHandler()
        this.alterProductImages = false
      } else {
        this.$message.error(res.msg)
        // this.$refs.upload3.clearFiles()
        this.$refs.upload4.clearFiles()
        this.cover = ''
        //this.fileList = []
        this.alterProductImages = false
      }
    },
    // 修改主封面和轮播图提交
    async updateMainArticleImages() {
      let fileFormData = new FormData()
      this.fileList.forEach((f) => {
        fileFormData.append('images', f.raw)
      })
      fileFormData.append('cover', this.cover)
      fileFormData.append('id', this.productKeyId)
      const { data: res } = await this.$http.post(`/admin/product/uploadMainProductImage`, fileFormData)
      if (res.code == 200) {
        this.$message.success('修改成功')
        this.$refs.upload3.clearFiles()
        this.$refs.upload4.clearFiles()
        this.recompose = {}
        this.cover = ''
        this.fileList = []
        this.updateHandler()
        this.mainAlterProductImages = false
      } else {
        this.$message.error(res.msg)
        this.$refs.upload3.clearFiles()
        this.$refs.upload4.clearFiles()
        this.cover = ''
        this.fileList = []
        this.mainAlterProductImages = false
      }
    },
    // 修改产品介绍图片提交
    async uploadProductInfoImage() {
      let fileFormData = new FormData()
      this.fileList.forEach((f) => {
        fileFormData.append('images', f.raw)
      })
      fileFormData.append('id', this.productId)
      const { data: res } = await this.$http.post(`/admin/product/uploadProductInfoImage`, fileFormData)
      if (res.code == 200) {
        this.$message.success('修改成功')
        this.$refs.productImg.clearFiles()
        this.recompose = {}
        this.fileList = []
        this.updateHandler()
      } else {
        this.$message.error(res.msg)
        this.$refs.productImg.clearFiles()
        this.fileList = []
      }
      this.ProductInfoImage = false
    },

    // 主产品封面和轮播图：多选轮播图 change
    mainImagesChange(file, fileList) {
      this.fileList = fileList
      // 以下为无效死代码，暂注释保留
      // this.fileList.forEach((f) => {
      //   this.formData.set(f.name, f.raw)
      // })
      // this.codeFile = file
      // this.codeFileList = fileList
      // if (fileList.length == 1) {
      //   let { images, ...data } = this.rules
      //   this.rules = data
      // }
      // this.$refs.recompose.clearValidate('images')
      // this.hideCode = fileList.length >= this.limitCode
    },
    // 主产品封面和轮播图：封面 change
    mainCoverChange(file, fileList) {
      this.cover = file.raw
      // 以下为无效死代码，暂注释保留
      // this.codeFile = file
      // this.codeFileList = fileList
      // if (fileList.length == 1) {
      //   let { cover, ...data } = this.rules
      //   this.rules = data
      // }
      // this.$refs.recompose.clearValidate('cover')
      // console.log(this.$refs.recompose.clearValidate())
      // this.hideCode = fileList.length >= this.limitCode
    },
    // 主产品封面和轮播图：移除
    mainImagesRemove(file, fileList) {
      // 以下为无效死代码，暂注释保留
      // if (fileList.length == 0) {
      //   this.rules.images = [{ required: true, message: '请上传图片文件', trigger: 'change' }]
      // }
      // this.hideUpload = fileList.length >= this.limitCount
      // 移除后同步 this.fileList，避免提交时携带已删除的图片
      if (this.fileList.indexOf(file) !== -1) {
        this.fileList = fileList
      }
    },
    // 产品封面：封面 change（逻辑与主产品一致）
    productCoverChange(file, fileList) {
      this.cover = file.raw
      // 以下为无效死代码，暂注释保留
      // this.codeFile = file
      // this.codeFileList = fileList
      // if (fileList.length == 1) {
      //   let { cover, ...data } = this.rules
      //   this.rules = data
      // }
      // this.$refs.recompose.clearValidate('cover')
      // console.log(this.$refs.recompose.clearValidate())
      // this.hideCode = fileList.length >= this.limitCode
    },
    // 产品封面：移除（逻辑与主产品一致）
    productCoverRemove(file, fileList) {
      // 以下为无效死代码，暂注释保留
      // if (fileList.length == 0) {
      //   this.rules.images = [{ required: true, message: '请上传图片文件', trigger: 'change' }]
      // }
      // this.hideUpload = fileList.length >= this.limitCount
      // 移除后同步 this.fileList，避免提交时携带已删除的图片
      if (this.fileList.indexOf(file) !== -1) {
        this.fileList = fileList
      }
    },
    handleRemoves(file, fileList) {
      if (fileList.length == 0) {
        this.rules.cover = [{ required: true, message: '请上传封面', trigger: 'change' }]
      }
      this.hideUpload = fileList.length >= this.limitCount
    },
    // 返回
    back() {
      this.$router.push({ path: '/product', query: { pageNum: this.pageNum } })
    }
  }
}
</script>
<style lang='scss' scoped>
.chain {
  display: flex;
  margin-bottom: 15px;
  .chain1 {
    font-weight: 600;
    margin-right: 15px;
  }
  .chainRight {
    display: flex;
    margin-right: 10px;
    .identity {
      margin-right: 10px;
      font-weight: 600;
    }
  }
}
.rebate {
  display: flex;
  margin-bottom: 15px;
  .identity {
    margin-right: 15px;
    font-weight: 600;
  }
}
.label-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
</style>